window.loadMondoSwiper = window.loadMondoSwiper || (() => {
  if (window.Swiper) return Promise.resolve();
  if (window.__mondoSwiperPromise) return window.__mondoSwiperPromise;

  const assets = window.themeAssetUrls || {};

  if (assets.swiperCss && !document.querySelector(`link[href="${assets.swiperCss}"]`)) {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = assets.swiperCss;
    document.head.appendChild(stylesheet);
  }

  window.__mondoSwiperPromise = new Promise((resolve, reject) => {
    if (!assets.swiperJs) {
      reject(new Error('Missing Swiper asset URL'));
      return;
    }

    const existingScript = document.querySelector(`script[src="${assets.swiperJs}"]`);
    if (existingScript) {
      existingScript.addEventListener('load', resolve, { once: true });
      existingScript.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = assets.swiperJs;
    script.defer = true;
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

  return window.__mondoSwiperPromise;
});
